// redux/reducers/usuarios.js
import {
  FETCH_USUARIOS_SUCCESS,
  FETCH_USUARIOS_FAILURE,
} from "../actions/usuarios/types";

const initialState = {
  data: [],
  error: null,
};

const usuariosReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_USUARIOS_SUCCESS:
      return {
        ...state,
        data: action.payload,
      };

    case FETCH_USUARIOS_FAILURE:
      return {
        ...state,
        data: action.payload,
      };
    default:
      return state;
  }
};

export default usuariosReducer;
